import KanbanBoard from './KanbanBoard.container';

export default KanbanBoard;